import React, { useSyncExternalStore } from 'react';
import { Button as AntButton } from 'antd';
import { Button as MuiButton, IconButton } from '@mui/material';
import { can, canZone } from './policy';
import { pageModule } from './usePermissions';
import store from '../store';

export function currentCan(moduleId, action = 'update') {
  const [path, query = ''] = window.location.hash.slice(1).split('?');
  return can(store.getState().user, moduleId || pageModule(path, query), action);
}

export default function PermissionButton({ permissionModule, permissionAction, permissionAny, permissionLibrary = 'antd', disabled, ...props }) {
  const user = useSyncExternalStore(store.subscribe, store.getState, store.getState).user;
  const [path, query = ''] = window.location.hash.slice(1).split('?');
  const id = permissionModule || pageModule(path, query);
  const allowed = permissionAny ? permissionAny.some(([module, action]) => can(user, module, action)) : !permissionAction || (permissionAction === 'zoning' ? canZone(user) : can(user, id, permissionAction));
  const Component = permissionLibrary === 'mui' ? MuiButton : permissionLibrary === 'icon' ? IconButton : AntButton;
  if (!allowed) return null;
  return <Component {...props} disabled={Boolean(disabled)} />;
}
PermissionButton.Group = AntButton.Group;
